import type { PropsWithChildren } from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { styled } from '@mui/material/styles';

const GroupButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'itemSelected',
})<{ itemSelected: boolean }>(({ itemSelected, theme }) => ({
  color: itemSelected ? theme.palette.primary.main : theme.palette.text.primary,
  fontWeight: itemSelected ? 'bold' : 'normal',
}));

interface ButtonItemProps {
  value: string;
  itemSelected: boolean;
  handleClick: () => void;
}

const ButtonItem: React.FC<PropsWithChildren<ButtonItemProps>> = ({
  children,
  value,
  itemSelected,
  handleClick,
}) => (
  <GroupButton value={value} onClick={handleClick} itemSelected={itemSelected}>
    {children}
  </GroupButton>
);

interface ButtonGroupProps {
  componentGroup: string;
  setComponentGroup: (value: string) => void;
}
export const ButtonGroupComponent: React.FC<ButtonGroupProps> = ({
  componentGroup,
  setComponentGroup,
}) => (
  <ButtonGroup
    size="small"
    aria-label="small button group"
    variant="contained"
    color="secondary"
    sx={{ ml: 2, position: 'relative', top: 12 }}
  >
    <ButtonItem
      key="all"
      value="all"
      handleClick={() => {
        setComponentGroup('all');
      }}
      itemSelected={componentGroup === 'all'}
    >
      All
    </ButtonItem>
    <ButtonItem
      key="global"
      value="global"
      handleClick={() => {
        setComponentGroup('global');
      }}
      itemSelected={componentGroup === 'global'}
    >
      Global
    </ButtonItem>
    <ButtonItem
      key="local"
      value="local"
      handleClick={() => {
        setComponentGroup('local');
      }}
      itemSelected={componentGroup === 'local'}
    >
      Local
    </ButtonItem>
  </ButtonGroup>
);
